import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

import { constant } from './constant'

import { useState } from '@/hooks'

Swiper.use([Navigation])

type State = {
	swiper?: Swiper
}

export const SwiperComponent = (() => {
	const { state, setState } = useState<State>({
		swiper: undefined,
	})

	const initSwiper = () => {
		if (state.swiper) {
			state.swiper.destroy(true)
		}

		const swiper = new Swiper(constant.container, {
			direction: 'horizontal',
			followFinger: true,
			observer: true,
			observeParents: true,
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			},
			pagination: {
				el: constant.paginator,
				clickable: true,
			},
			slidesPerView: 1,
			autoHeight: true,
			navigation: {
				nextEl: constant.buttonNext,
				prevEl: constant.buttonPrevious,
			},
		})

		setState({ swiper })
	}

	const init = () => {
		initSwiper()
	}

	return {
		init,
	}
})()
